"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var siCountry = exports.siCountry = function siCountry(t) {
  return {
    id: 'SI',
    name: t('Slovenia'),
    flag: '🇸🇮',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 4;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1000 or 2000',
    phonePrefix: '386',
    phoneLength: 8,
    pricingVersion: 14,
    timezone: 'Europe/Ljubljana',
    currency: 'EUR'
  };
};